import React, { useEffect, useState } from "react"
import Cookies from 'js-cookie'
import { loginSuccess, logout } from '../actions'
import { useRouter } from 'next/router'
import { UserServices } from '../services'
import { LoadingOverlay } from 'components/common'
import { AppConfigServices, AuthServices } from "services/index"
import i18n from 'config/i18n'
import {
  setAccessToken,
  setTurnServer
} from "actions"
import { setIdentifyVerificationModal, setQuestBonusModal, setVerifyAgeModal } from "actions/mainContent"

/**
 * Protect private routes
 * @param {Component} Component 
 * Must always come with redux connect with isLogged, user props in the parent Component
 * Example: connect(privateRouteMap)(PrivateRoute(Component))
 */

export const PrivateRoute = (Component) => {
  return (props) => {
    const { dispatch, user, accessToken, iceServers } = props
    const [isLoading, setIsLoading] = useState(false)
    const router = useRouter()

    useEffect(() => {
      let queries = new URLSearchParams(location.search)
      let token = Cookies.get('accessToken')

      if (queries.get('auth')) {
        getAccessToken(queries.get('auth'))
      } else {
        if (token) {
          dispatch(setAccessToken(token))
        } else {
          if (!accessToken) {
            dispatch(setAccessToken(null))
            location.pathname = location.pathname.replace('live', 'login')
          }
        }
      }
    }, [])

    useEffect(() => {
      if (!user && accessToken) {
        getCurrentUser()
      }

      // if (user?.role === 'user' && !user?.email_confirmed) {
      //   router.push('/confirm-email')
      // }

      // Check and get ice server
      if (accessToken && (!iceServers || iceServers && !iceServers.length)) {
        getIceServer()
      }
    }, [accessToken])
    const getIceServer = async () => {
      // Ice servers from cookie
      if (Cookies.get('turn_server')) {
        dispatch(setTurnServer(JSON.parse(Cookies.get('turn_server'))))
        return;
      }

      // let { turn_server } = await AppConfigServices.getTurnServer()

      // if (turn_server) {
      //   Cookies.set('turn_server', turn_server)
      //   dispatch(setTurnServer(JSON.parse(turn_server)))
      // }
    }

    const getAccessToken = async (auth) => {
      setIsLoading(true)
      const { token } = await AuthServices.getAccessTokenByAuth(auth)
      setIsLoading(false)

      if (token) {
        dispatch(setAccessToken(token))
        Cookies.set('accessToken', token, { expires: 30 })
      } else {
        dispatch(setAccessToken(null))
        router.push('/login')
      }
    }

    const getCurrentUser = async () => {
      try {
        setIsLoading(true)
        const { user, error } = await UserServices.getProfile()
        setIsLoading(false)

        if (error) throw error?.message

        if (user?.is_show_verify_age) {
          dispatch(setVerifyAgeModal(true))
        }

        if (user?.is_show_verify_identity) {
          dispatch(setIdentifyVerificationModal(true))
        }

        if (user?.is_allow_mobile_bonus) {
          dispatch(setQuestBonusModal(true))
        }
        
        dispatch(loginSuccess(user, accessToken))

        // Check email is verified
        // if (user?.role === 'user' && !user?.email_confirmed) {
        //   router.push('/confirm-email')
        // } else {
          i18n.changeLanguage(user.language)
          
          if (user?.gender === null || !user?.gender_verified && user?.gender === 1) {
            router.push('/verify-gender')
          }
        // }
      } catch (e) {
        dispatch(logout())
        dispatch(setAccessToken(null))
        Cookies.remove('accessToken')
        router.push('/')
      }
    }

    if (user) {
      return <Component {...arguments} {...props} />
    } else {
      if (isLoading) {
        return <LoadingOverlay />
      } else {
        return <></>
      }
    }
  }
}